export default "__VITE_ASSET__8f14c236__"